import React from 'react'
import { connect } from 'react-redux'
import CartItem from './CartItem'
import { CheckoutSection } from '../../components'
import { deleteItemAsync, updateItemQuantityAsync, updateItemQuantity, getOrderTypeAsync } from './cartActionCreators'

const CartList = ({ items, onQuantityChange, onDelete, translationUtility }) => {
  const cartItems = items.map((item) => {
    return (
      <CartItem
            key={item.Id}
            item={item}
            onQuantityChange={onQuantityChange}
            onDelete={onDelete}
            translationUtility={translationUtility}
      />
    );
  });
  return (
    <CheckoutSection label={translationUtility.translateResourceString("/Checkout/ShoppingCart/Label")} hideBodyBorder={true}>
        {cartItems}
    </CheckoutSection>
  );
}

const cartListMapStateToProps = (state, ownProps) => {
  return {
    items: state.entities.CartItems,
    ...ownProps
  }
}

const cartListMapDispatchToProps = (dispatch, ownProps) => {
  return {
    onQuantityChange: (id, value) => {
      dispatch(updateItemQuantityAsync({id, qty: value}));
      dispatch(getOrderTypeAsync());
    },
    onDelete: (id, prevQty) => {
      if (typeof window !== 'undefined' && typeof window.confirm !== 'undefined' && window.confirm(ownProps.translationUtility.translateResourceString("/Checkout/ShoppingCart/ConfirmDelete"))) { 
        dispatch(deleteItemAsync({id}))
      } else {
        dispatch(updateItemQuantity(id, prevQty > 0 ? prevQty : 1))
      }
      dispatch(getOrderTypeAsync());
    }
  }
}

const CartListContainer = connect(cartListMapStateToProps, cartListMapDispatchToProps)(CartList);

export default CartListContainer



// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Cart/CartList.jsx